import PrintIcon from '@mui/icons-material/Print';
import { Box, IconButton } from '@mui/material';
import React, { RefObject } from 'react';
import CustomTooltip from '../../shared/CustomTooltip';
import { printPolicyDocument } from './policyDocumentExport';

type PolicyDocumentActionsProps = {
    contentRef: RefObject<HTMLElement | null>;
    title: string;
};

const PolicyDocumentActions = ({
    contentRef,
    title,
}: PolicyDocumentActionsProps) => {
    const handlePrint = () => {
        if (contentRef.current) {
            printPolicyDocument(contentRef.current, title);
        }
    };

    return (
        <Box
            className='policy-document-actions'
            sx={{ display: 'flex', flexShrink: 0 }}
        >
            <CustomTooltip title='Print'>
                <IconButton
                    size='small'
                    onClick={handlePrint}
                    aria-label='Print'
                >
                    <PrintIcon fontSize='small' />
                </IconButton>
            </CustomTooltip>
        </Box>
    );
};

export default PolicyDocumentActions;
